export const ROLES = {
    ADMIN: 'Admin',
    EDITOR: 'Editor',
    VIEWER: 'Viewer'
}

export const USER_TYPE = {
    MANAGED: 'managed',
    NON_MANAGED: 'non-managed'
}